import { BrandInfoActionsUnion, BrandInfoActionTypes } from './brand-info.actions';
import { BrandInfoInitialState } from './brand-info.state';

export function brandInfoReducer(
  state = BrandInfoInitialState,
  action: BrandInfoActionsUnion
) {
  switch (action.type) {
    case BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT:
      return { ...state };
    case BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT_SUCCESS:
      const { response } = action.payload;

      return {
        ...state,
        ...response,
      };
    case BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT_FAILURE:
      return {
        ...state,
        id: '',
        name: '',
        slug: '',
        productsCount: 0,
        categoriesCount: 0,
        categories: [],
      };
    case BrandInfoActionTypes.RESET_BRAND_INFO:
      return BrandInfoInitialState;
    default:
      return state;
  }
}
